import { isEmpty, startCase } from 'lodash';
import sortBy from 'lodash/sortBy';
import { ArrField, ProjectFeeField } from 'components/organisms/dashboard/use-filter-fields';
import { filterableFieldType } from 'components/organisms/tasks/fields';
export const findLowestStartDay = (data)=>{
    var _data_;
    return data.reduce((min, p)=>p.startDay < min ? p.startDay : min, ((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.startDay) || 1);
};
export const findLargestSumOfStartDayDuration = (data)=>{
    const { duration, startDay } = data.reduce((prev, p)=>{
        const currentTaskSum = p.startDay + p.duration;
        const prevTaskSum = prev.startDay + prev.duration;
        return currentTaskSum > prevTaskSum ? p : prev;
    }, data[0] || {
        duration: 0,
        startDay: 1
    });
    return startDay + duration;
};
export const insert = (arr, index, newItem)=>[
        ...arr.slice(0, index),
        newItem,
        ...arr.slice(index)
    ];
const EMPTY_ARRAY = [];
export const getDynamicConditionFields = (projectCustomFields, includeDefaultFields = true)=>{
    return isEmpty(projectCustomFields) ? EMPTY_ARRAY : sortBy([
        ...includeDefaultFields ? [
            ArrField,
            ProjectFeeField
        ] : [],
        ...projectCustomFields.map((x)=>({
                ...x,
                type: filterableFieldType(x)
            }))
    ].filter((x)=>Boolean(x)), ({ fieldLabel, fieldName })=>fieldLabel !== null && fieldLabel !== void 0 ? fieldLabel : startCase(fieldName));
};
